import AboutHubsynch from "@/views/static-pages/AboutHubsynch.vue";
import { createRouter, createWebHistory } from "vue-router";
import Login from "@/views/Login.vue";
import { useAuthStore } from "@/stores/authStore";
import TopPage from "@/views/TopPage.vue";
import Reminder from "@/views/Reminder.vue";
import ReminderComplete from "@/views/ReminderComplete.vue";
import Error from "@/views/Error.vue";
import NotFound from "@/errors/NotFound.vue";
import InternalServerError from "@/errors/InternalServerError.vue";
import HubsynchUsing from "@/views/static-pages/HubsynchUsing.vue";
import HubsynchFlow from "@/views/static-pages/HubsynchFlow.vue";
import HubsynchStrongPoint from "@/views/static-pages/HubsynchStrongPoint.vue";
import MerchantTerms from "@/views/static-pages/MerchantTerms.vue";
import UserTerms from "@/views/static-pages/UserTerms.vue";
import AttentionPlease from "@/views/static-pages/AttentionPlease.vue";
import UserAccountFee from "@/views/static-pages/UserAccountFee.vue";
import Faq from "@/views/static-pages/Faq.vue";
import CategoryAccount from "@/views/static-pages/CategoryAccount.vue";
import Biz from "@/views/static-pages/Biz.vue";
import HowToSignUp from "@/views/static-pages/HowToSignUp.vue";
import CreditCardList from "@/views/CreditCardList";
import TransactionHistory from "@/views/TransactionHistory.vue";
import Subscribers from "@/views/Subscribers.vue";
import routesAvailable from '@/data/routes.json';
import RegisterAgreement from "@/views/RegisterAgreement.vue";
import RegisterVerify from "@/views/RegisterVerify.vue";
import RegisterVerifyCompleted from "@/views/RegisterVerifyCompleted.vue";
import EditAccount from "@/views/EditAccount.vue";
import EditAccountConfirm from "@/views/EditAccountConfirm.vue";
import EditAccountFinish from "@/views/EditAccountFinish.vue";
import EditUser from "@/views/EditUser.vue";
import MerchantList from "@/views/MerchantList.vue";
import ContactUs from "@/views/ContactUs.vue";
import ShippingAddresses from "@/views/ShippingAddresses.vue";
import NewsList from "@/views/NewsList.vue";
import PublicPersonalInformation from "@/views/PublicPersonalInformation.vue";
import PrivacyPolicy from "@/views/static-pages/PrivacyAndPolicy.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import PersonalInformation from "@/views/PersonalInformation.vue";
import AccountDeleted from "@/views/AccountDeleted.vue";
import Index from "@/views/Index.vue";
import Company from "@/views/Company.vue";
import HowToInstall from "@/views/static-pages/HowToInstall.vue";
import Conbini from "@/views/blogs/Conbini.vue";
import FamilyMart from "@/views/blogs/FamilyMart.vue";
import Lawson from "@/views/blogs/Lawson.vue";
import Ministop from "@/views/blogs/Ministop.vue";
import Sunkus from "@/views/blogs/Sunkus.vue";
import Yamazaki from "@/views/blogs/Yamazaki.vue";
import SeicoMart from "@/views/blogs/SeicoMart.vue";
import MarketPlace from "@/views/blogs/MarketPlace.vue";
import UserAccount from "@/views/blogs/UserAccount.vue";
import {useUserStore} from "@/stores/userStore";

const validateUserInfo = async (to, from) => {
    const userStore = useUserStore();
    if (userStore._isValidUserInfo !== undefined) {
        if (!userStore._isValidUserInfo) {
            return { name: 'edit.account' };
        }
        return true;
    }
    try {
        const isValid = await userStore.isValidUserInfo();
        userStore._isValidUserInfo = isValid;
        if (!isValid) {
            return { name: 'edit.account' };
        }
        return true;
    } catch (e) {
        if (e && e.name === 'ApplicationError') {
            return { name: 'login' };
        }
        return { name: 'error', params: { code: 500, message: 'Unexpected error' } };
    }
};

const routes = [
    {
        path: "/about-hubsynch",
        name: "about.hubsynch",
        component: AboutHubsynch,
    },
    {
        path: "/",
        name: "home",
        component: Index,
    },
    {
        path: "/login",
        name: "login",
        component: Login,
    },
    {
        path: "/register-agreement",
        name: "register.agreement",
        component: RegisterAgreement,
    },
    {
        path: "/register-verify",
        name: "register.verify",
        component: RegisterVerify,
    },
    {
        path: "/register-verify/completed",
        name: "register.verify.completed",
        component: RegisterVerifyCompleted,
    },
    {
        path: "/top-page",
        name: "top.page",
        component: TopPage,
        beforeEnter: validateUserInfo
    },
    {
        path: "/reminder",
        name: "reminder",
        component: Reminder,
    },
    {
        path: "/reminder-complete",
        name: "reminder.complete",
        component: ReminderComplete,
    },
    {
        path: "/merchant-list",
        name: "merchant.list",
        component: MerchantList,
        beforeEnter: validateUserInfo
    },
    {
        path: "/hubsynch-using",
        name: "hubsynch.using",
        component: HubsynchUsing
    },
    {
        path: "/hubsynch-flow",
        name: "hubsynch.flow",
        component: HubsynchFlow
    },
    {
        path: "/hubsynch-strong-point",
        name: "hubsynch.strong.point",
        component: HubsynchStrongPoint
    },
    {
        path: "/marchant-terms",
        name: "merchant.terms",
        component: MerchantTerms
    },
    {
        path: "/user-terms",
        name: "user.terms",
        component: UserTerms
    },
    {
        path: "/attention-please",
        name: "attention.please",
        component: AttentionPlease
    },
    {
        path: "/hubsynch-user-account-fee",
        name: "user.account.fee",
        component: UserAccountFee
    },
    {
        path: "/faq",
        name: "faq",
        component: Faq
    },
    {
        path: "/category-account",
        name: "category.account",
        component: CategoryAccount
    },
    {
        path: "/biz",
        name: "biz",
        component: Biz
    },
    {
        path: "/how-to-sign-up",
        name: "how.to.sign.up",
        component: HowToSignUp
    },
    {
        path: "/credit-cards",
        name: "credit.cards",
        component: CreditCardList
    },
    {
        path: "/transaction-history",
        name: "transaction.history",
        component: TransactionHistory,
        beforeEnter: validateUserInfo
    },
    {
        path: "/edit-account",
        name: "edit.account",
        component: EditAccount,
        beforeEnter: async (to, from) => {
            const userStore = useUserStore();

            if (await userStore.isValidUserInfo()) {
                return { name: 'top.page' }; // Redirect to Toppage if not from allowed route
            }
        }
    },
    {
        path: "/edit-account-confirm",
        name: "edit.account.confirm",
        component: EditAccountConfirm,
        beforeEnter: (to, from) => {
            // Only allow if coming from the 'edit.account' route name
            if (from.name === 'edit.account') {
                return true; // Allow navigation
            } else {
                return { name: 'top.page' }; // Redirect to Toppage if not from allowed route
            }
        }
    },
    {
        path: "/edit-account-finish",
        name: "edit.account.finish",
        component: EditAccountFinish,
        beforeEnter: (to, from) => {
            // Only allow if coming from the 'edit.account.confirm' route name
            if (from.name === 'edit.account.confirm') {
                return true; // Allow navigation
            } else {
                return { name: 'top.page' }; // Redirect to Toppage if not from allowed route
            }
        }
    },
    {
        path: "/user-profile",
        name: "user.profile",
        component: EditUser,
        beforeEnter: validateUserInfo,
    },
    {
        path: "/subscribers",
        name: "subscriber",
        component: Subscribers
    },
    {
        path: "/contactus",
        name: "contact.us",
        component: ContactUs
    },
    {
        path: "/shipping-addresses",
        name: "shipping.addresses",
        component: ShippingAddresses,
        beforeEnter: validateUserInfo,
    },
    {
        path: "/news-list",
        name: "news.list",
        component: NewsList,
        beforeEnter: validateUserInfo,
    },
    {
        path: "/kojinjoho",
        name: "public.personal.information",
        component: PublicPersonalInformation
    },
    {
        path: "/privacypolicy",
        name: "privacy.policy",
        component: PrivacyPolicy
    },
    {
        path: "/terms-of-use",
        name: "terms.of.use",
        component: TermsOfUse
    },
    {
        path: "/account-deleted",
        name: "account.deleted",
        component: AccountDeleted
    },
    {
        path: "/personal-information",
        name: "personal.information",
        component: PersonalInformation
    },
    {
        path: "/error",
        name: "error",
        component: Error,
        beforeEnter: (to, from, next) => {
            to.state = {
                code: to.params.code,
                message: to.params.message,
            };
            next();
        },
    },
    {
        path: '/:catchAll(.*)',
        component: NotFound,
    },
    {
        path: '/page-not-found',
        component: NotFound,
        name: "page.not.found"
    },
    {
        path: '/internal-server-error',
        component: InternalServerError,
        name: 'internal.server.error'
    },
    {
        path: '/company',
        component: Company,
        name: 'company'
    },
    {
        path: '/how-to-install',
        component: HowToInstall,
        name: 'how.to.install'
    },
    {
        path: '/blog/559',
        component: Conbini,
        name: 'blog.559'
    },
    {
        path: '/blog/593',
        component: FamilyMart,
        name: 'blog.593'
    },
    {
        path: '/blog/590',
        component: Lawson,
        name: 'blog.590'
    },
    {
        path: '/blog/611',
        component: Ministop,
        name: 'blog.611'
    },
    {
        path: '/blog/602',
        component: Sunkus,
        name: 'blog.602'
    },
    {
        path: '/blog/756',
        component: Yamazaki,
        name: 'blog.756'
    },
    {
        path: '/blog/617',
        component: SeicoMart,
        name: 'blog.617'
    },
    {
        path: '/blog/333',
        component: MarketPlace,
        name: 'blog.333'
    },
    {
        path: '/blog/121',
        component: UserAccount,
        name: 'blog.121'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0 }
    },
});

router.beforeEach(async (to, from) => {

    if (routesAvailable[to.name] === false) {
        return { name: "page.not.found" };
    }

    const authStore = useAuthStore();
    const isAuth = await authStore.checkSession();

    const openedRoutes = [
        "login",
        "registration",
        "reminder",
        "reminder.complete",
        "register.agreement",
        "register.verify",
        "register.verify.completed",
        "home",
    ];

    const publicRoutes = [
        "account.deleted",
        "about.hubsynch",
        "public.personal.information",
        "hubsynch.using",
        "hubsynch.flow",
        "hubsynch.strong.point",
        "merchant.terms",
        "user.terms",
        "attention.please",
        "user.account.fee",
        "faq",
        "category.account",
        "biz",
        "contact.us",
        "how.to.sign.up",
        "company",
        "how.to.install",
        "privacy.policy",
        "blog.559",
        "blog.593",
        "blog.590",
        "blog.611",
        "blog.602",
        "blog.756",
        "blog.617",
        "blog.333",
        "blog.121",
        "news.list",
    ];

    if (publicRoutes.includes(to.name)) {
        return;
    }

    if (!isAuth && !openedRoutes.includes(to.name)) {
        return { name: "login" };
    } else if (isAuth && openedRoutes.includes(to.name)) {
        return { name: "top.page" };
    }
});

export default router;
